import Text from "components/common/Text/Text";
import styled from "themes";
import theme from "themes/simple-theme";

export const FormSubmitStatusText = styled(Text)`
  margin-bottom: 0;
  font-size: ${theme.fontSize.s};
`;



// WEBPACK FOOTER //
// ./src/components/common/Form/FormSubmitStatusText/FormSubmitStatusText.style.tsx